export const ACCOUNT_DOCUMENT_DROP_DOWN_ITEMS = []